//路由（菜单）名称替换器相关配置
import store from '../store'

//黄姚平台菜单（需要替换的）名字
function getHuangYaoConfig() {
  return [
    {
      name: 'YunCang',//路由名称云仓（）
      title: '旅游云仓'//新名字
    }
  ]
}

//(平台)禁用菜单配置文件
const platformConfig = [
  {
    platformTag: 'huangYao',
    getConfig: () => getHuangYaoConfig()
  }

]

//通过平台Id获取禁用菜单
function getConfigListByTag(platformTag) {
  if (platformTag) {
    let findItem = platformConfig.find(item => item.platformTag === platformTag)
    if (findItem) {
      return findItem.getConfig()
    }
  }
  return []
}

//路由替换信息列表
export default function getMenuReplacerList() {
  let platformConfig = store.getters.platformConfig
  let platformTag = platformConfig.platformTag
  return getConfigListByTag(platformTag)
}

